export default __webpack_public_path__ + "static/media/NGA.cc607319.png";